const translations = {
  title: 'Places',
  title_person: 'People',
  title_fleet: 'Fleet',
  'menu.triggers': 'Automations',
  'menu.integrations': 'Integrations',
  'menu.import': 'Import',
  'menu.importHistory': 'Import history',
  'menu.export': 'Export',
  'menu.exportHistory': 'Export history',
  'menu.levelsSettings': 'Customize levels',
  'menu.fieldsSettings': 'Customize additional fields',
  'menu.templates': 'Document Templates',
  'menu.templateHistory': 'Document History',
  'menu.qrcode': 'QR Code Generator',
  'menu.buckets': 'QR Code batch history',
  'menu.linktree': 'Customize QR Code menu',
  'menu.publicToken': 'Public tokens',
  'menu.placeType': 'Edit place type name',
  'menu.placeLevelsEdit': 'Level registration',
  moreOptions: 'More options',
  cardViewSoon: 'Card view (coming soon)',
  activated: 'Activated',
  levels: 'Levels',
  assets: 'Assets',
  noQrcodeFound: 'No QR Code found',
  'fields.NAME': 'Name',
  'fields.INSERTED_AT': 'Creation date',
  'fields.UPDATE_AT': 'Update date',
  'guide.text':
    "In places, you will create all your client's locations where you will perform your services, external or internal. Places are based on a 4-level registration structure that can be customized to best serve your operation!",
  'guide.howToCreate': 'How to create a place?',
  'guide.howToEdit': 'How to edit a place?',
  'guide.howToDelete': 'How to delete a place?',
  'guide.howToEditLevels': 'How to edit place levels?',
  'guide.howToEditFields': 'How to edit which additional fields a place should have?',
  'guide.contact': 'Get in touch and clear your doubts'
}

export default translations
